<div
    class="app-banner cipo-bg--primary-100 cipo--cursor--pointer"
    fxLayout
    fxLayoutAlign="start center"
    fxLayoutGap="8px"
    tabindex="0"
    role="button"
    (click)="openApp()"
    (keydown.enter)="openApp()"
    (keydown.space)="onBannerSpace($event)">
    <img src="/src/assets/icons/favicon-60x60.png" alt="CIPO Software" class="app-banner__icon" fxFlex="none" />
    <div fxLayout="column" fxFlex>
        <span class="app-banner__name">CIPO Software</span>
        <span class="app-banner__sub">{{ "mobileBanner.subtitle" | translate }}</span>
    </div>
    <button mat-flat-button color="primary" fxFlex="none">{{ "mobileBanner.getApp" | translate }}</button>
    <button
        mat-icon-button
        fxFlex="none"
        (click)="$event.stopPropagation(); dismiss()"
        [attr.aria-label]="'mobileBanner.close' | translate">
        <mat-icon aria-hidden="true">close</mat-icon>
    </button>
</div>
